import { PanelHeaderStyle, PanelWrapperStyle } from 'src/styles/panel.style';
import styled from 'styled-components';


type PanelProps = {
  customDateRange: boolean;
};

export const Wrapper = styled.div`
    flex: 0 0 auto;
    max-width: 30%;
    position: relative;
`;

export const UpperWrapper = styled.div`
    display: flex;
    align-items: start;
    justify-content: space-between;
`;

export const PanelWrapper = styled(PanelWrapperStyle) <PanelProps>`
  right: ${(props) => (props.customDateRange ? '-515px;' : '-270px;')}
  top: 45px;
  width: ${(props) => (props.customDateRange ? '565px;' : '320px;')}
  height: 465px;
  h4{
    font-size: 0.9rem;
    font-weight: 500;
    height: 50px;
    color: #fff;
    padding: 10px;
    border-bottom: 1px solid #ddd;
    button{
      margin: 0 5px;
    }
  }

  .voyage-list {
    font-size: 0.8rem;
    height: calc(100% - 50px);
    overflow-y: auto;
   
    li{
      display: flex; 
      justify-content: flex-start;
      align-items: center;
      padding: 5px 0;
      border-bottom: 1px solid #ddd;
      grid-gap: 10px;
      button{
        margin: 0 5px;
      }
    }
  }
`;

export const PanelHeader = styled(PanelHeaderStyle)`
    padding: 0.75rem;
    button{
      margin: 0 5px;
    }
`;

export const FiltersSelectionWrapper = styled.div`
    color: #e65100;
    font-weight: 400;
    font-size: 0.9rem;
    padding: 2px;
    position: relative;
    //padding: 10px;
    .selected-rotation-label {
        font-weight: 500;
        margin-right: 3px;
    }
`;

export const SelectedRotationsWrapper = styled.div`
    font-weight: 400;
    font-size: 0.9rem;
    position: relative;
    margin: 0 0 0 10px;
    .info-text {
        display: block;
        font-size: 0.7rem;
    }
`;

export const PeriodSelectionWrapper = styled.div`
    padding: 8px 20px;
`;

export const SetButton = styled.button`
    width: 35px;
    &:hover {
        cursor: pointer;
    }
    &:disabled {
        cursor: unset;
        background-color: #cccccc;
        color: #666666;
        opacity: 0.7;
    }
`;
